var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehanceicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.67 70.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.67,
    height: 70.67,
    fill: "#000",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.42,37.05c.17,0,.33.01.5.02v-2.9c-.03-.14-.06-.29-.09-.43-.24-1.19-.35-2.42-.74-3.55-.85-2.44-2.37-4.4-4.7-5.6-2.94-1.51-6.05-1.76-9.23-1.03-3.53.81-6.09,2.86-7.44,6.26-1.22,3.08-1.26,6.27-.63,9.49.56,2.84,2.07,4.99,4.57,6.49,2.86,1.71,5.93,2.16,9.19,1.71,3.42-.47,6.09-2.12,7.91-5.08.42-.68.74-1.4.81-2.24-.09-.02-.16-.04-.22-.04-1.9,0-3.8-.01-5.7.01-.17,0-.37.17-.5.31-.43.45-.78,1.02-1.27,1.38-1.41,1.03-3.04,1.09-4.69.77-2.76-.53-4.31-2.72-4.24-5.57h.53c5.32,0,10.63,0,15.95,0ZM49.93,28.21c2.81.28,4.54,2.18,4.57,4.83h-10.45c.53-3.43,2.64-5.15,5.88-4.83Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.07,31.43c-.66-.51-1.43-.89-2.17-1.34,0,0,.02-.02.05-.04.14-.08.29-.17.43-.25,1.65-.92,2.75-2.28,3.07-4.15.16-.94.21-1.93.13-2.88-.24-2.66-1.55-4.67-3.95-5.9-1.84-.94-3.83-1.19-5.86-1.2-4.83-.01-9.66,0-14.5,0h-.52v31.21h.38c4.65,0,9.3.02,13.95-.02,1.26,0,2.53-.13,3.78-.31,2.22-.31,4.12-1.27,5.59-3,1.79-2.12,2.45-4.59,2.15-7.3-.21-1.92-.96-3.61-2.52-4.82ZM16.03,21.14c.08-.02.15-.06.23-.06,2.75.03,5.5.04,8.25.1.57.01,1.15.16,1.72.29,1.19.27,1.86,1.05,2.05,2.23.13.8.07,1.59-.24,2.36-.34.83-1.01,1.29-1.82,1.5-.76.21-1.56.37-2.35.39-2.52.05-5.03.02-7.55.02-.08,0-.16-.01-.29-.02v-6.81ZM26.18,41.17c-.75.19-1.54.28-2.32.29-2.5.04-5,.02-7.49.02-.1,0-.19-.01-.33-.02v-8.27c.11-.01.21-.03.3-.03,2.73,0,5.46-.03,8.19.04.85.02,1.7.27,2.52.54.42.13.81.47,1.12.81,1.84,2.06.68,5.95-1.98,6.63Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.97,17.17h-13.51v3.8h13.51v-3.8Z",
    fill: "#fff",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 63.91,
    width: 70.67,
    height: 6.76,
    fill: "#785abf",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceicon);
export default __webpack_public_path__ + "static/media/behanceicon.44eebc18aeb1398b22b1825511bc5310.svg";
export { ForwardRef as ReactComponent };